import { createAction } from '@cobuildlab/react-simple-state';
import {
  createAnalyticsAuthenticationErrorEvent,
  createAnalyticsAuthenticationEvent,
  createAnalyticsErrorEvent,
  createAnalyticsEvent,
} from './analytic-event-events';
import axios from 'axios';
import { ANALYTICS_ENDPOINT } from '../../shared/constans';
import { getCurrentUrl } from '../auth/auth-utils';
import { AnalyticsEvents } from './analytics-event-types';

export const createAnalyticEvent = createAction(
  createAnalyticsEvent,
  createAnalyticsErrorEvent,
  async (data: { user_id: number; uuid: string; name: AnalyticsEvents }) => {
    const response = await axios.post(
      `${ANALYTICS_ENDPOINT}/create`,
      {
        name: data.name,
        user_id: data.user_id,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'analytics-session': data.uuid,
          'analytics-session-origin': getCurrentUrl(),
        },
      },
    );

    return response.data;
  },
);

export const createAnalyticAuthenticationAction = createAction(
  createAnalyticsAuthenticationEvent,
  createAnalyticsAuthenticationErrorEvent,
  async () => {
    const response = await axios.post(
      `${ANALYTICS_ENDPOINT}/authenticate`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          'analytics-session-origin': window.location.href,
        },
      },
    );

    return response.data;
  },
);
